import React from 'react';
import PropTypes from 'prop-types';

const templates = [
{ name: 'brief_1', component: require('./styl_brief_1').default },
{ name: 'brief_2', component: require('./styl_brief_2').default },
{ name: 'brief_3', component: require('./styl_brief_3').default },
{ name: 'brief_3_big', component: require('./styl_brief_3_big').default },
{ name: 'brief_4', component: require('./styl_brief_4').default },
{ name: 'brief_5', component: require('./styl_brief_5').default },
{ name: 'brief_6', component: require('./styl_brief_6').default },
{ name: 'brief_7', component: require('./styl_brief_7').default },
{ name: 'brief_8', component: require('./styl_brief_8').default },
{ name: 'brief_9', component: require('./styl_brief_9').default },
{ name: 'brief_10', component: require('./styl_brief_10').default },  //2.0版本热门
{ name: 'brief_11', component: require('./styl_brief_11').default },  //2.0本周推荐
{ name: 'brief_12', component: require('./styl_brief_12').default },  //2.0读者热评 90*116
{ name: 'brief_13', component: require('./styl_brief_13').default },  //2.0最近更新 
];

export default class Book extends React.Component {
    render() {
        for (const item of templates) {
            if (item.name === this.props.template) {
                return <item.component {...this.props} />;
            }
        }
        return <div />;
    }
}

Book.defaultProps = {
    template: 'brief_1',
};

Book.protoTypes = {
    novel_id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    pic: PropTypes.string,
    template: PropTypes.oneOf(templates.map(item => item.name))
};




// WEBPACK FOOTER //
// ./src/component/book/index.js